// Owner: shell-nav (wave 2). Unauthenticated pages (sign-in, setup, status, public forms, the developer
// pages in development builds) with a designed error state.
import { Outlet, createFileRoute } from '@tanstack/react-router';
import { PageError } from '../shell/states';

export const Route = createFileRoute('/_public')({
  component: Outlet,
  errorComponent: PageError,
});
